// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-color: #293241;

  --red-color: #e94b35;
  --orange-color: #e77f24;
  --yellow-color: #f1c518;
  --green-color: #4cb96c;
  --blue-color: #3796d2;
  --purple-color: #9459a4;

  --red-hc-color: #882255;
  --orange-hc-color: #cc6677;
  --yellow-hc-color: #ddcc77;
  --green-hc-color: #117733;
  --blue-hc-color: #88ccee;
  --purple-hc-color: #332288;

  --primary-text: #e2e1e4;
  --secondary-text: #f5deb3;

  --nunito-thin: 200;
  --nunito-light: 300;
  --nunito-regular: 400;
  --nunito-medium: 500;
  --nunito-bold: 700;
  --nunito-black: 900;
}

.light-theme {
  --primary-text: #293241;
  --secondary-text: #293241;
  --bg-color: #f5f5f5;
  --alt-color: #f5deb3;
}

.leckerli-one-regular {
  font-family: "Leckerli One", cursive;
  font-weight: 400;
  font-style: normal;
}

* {
  margin: 0;
  -webkit-tap-highlight-color: transparent;
}

body {
  height: 100%;
  align-items: center;
  background-color: var(--bg-color);
  display: flex;
  justify-content: center;
  margin: 0px;
  overflow: auto;
  padding: 0px;
  color: var(--primary-text);
  font-family: "Nunito Sans", sans-serif;
  border-bottom: 2px solid var(--secondary-text);
}

#root {
  width: 100%;
  text-align: center;
}

::selection {
  color: var(--bg-color);
  background: var(--secondary-text);
}

.light-theme ::selection {
  background-color: var(--primary-text);
  color: var(--alt-color);
}

::-webkit-scrollbar {
  width: 12px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: var(--secondary-text);
  border-radius: 6px;
  border: 3px solid transparent;
}

::-webkit-scrollbar-thumb:hover {
  background-color: var(--secondary-text);
}

html {
  scrollbar-width: thin;
  scrollbar-color: var(--secondary-text) transparent;
}

::-webkit-scrollbar-button {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;;EAEnB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;;EAEvB,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;;EAE1B,uBAAuB;EACvB,yBAAyB;;EAEzB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAYA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf","sourcesContent":[":root {\r\n  --bg-color: #293241;\r\n\r\n  --red-color: #e94b35;\r\n  --orange-color: #e77f24;\r\n  --yellow-color: #f1c518;\r\n  --green-color: #4cb96c;\r\n  --blue-color: #3796d2;\r\n  --purple-color: #9459a4;\r\n\r\n  --red-hc-color: #882255;\r\n  --orange-hc-color: #cc6677;\r\n  --yellow-hc-color: #ddcc77;\r\n  --green-hc-color: #117733;\r\n  --blue-hc-color: #88ccee;\r\n  --purple-hc-color: #332288;\r\n\r\n  --primary-text: #e2e1e4;\r\n  --secondary-text: #f5deb3;\r\n\r\n  --nunito-thin: 200;\r\n  --nunito-light: 300;\r\n  --nunito-regular: 400;\r\n  --nunito-medium: 500;\r\n  --nunito-bold: 700;\r\n  --nunito-black: 900;\r\n}\r\n\r\n.light-theme {\r\n  --primary-text: #293241;\r\n  --secondary-text: #293241;\r\n  --bg-color: #f5f5f5;\r\n  --alt-color: #f5deb3;\r\n}\r\n\r\n.leckerli-one-regular {\r\n  font-family: \"Leckerli One\", cursive;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n\r\n* {\r\n  margin: 0;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\nbody {\r\n  height: 100%;\r\n  align-items: center;\r\n  background-color: var(--bg-color);\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 0px;\r\n  overflow: auto;\r\n  padding: 0px;\r\n  color: var(--primary-text);\r\n  font-family: \"Nunito Sans\", sans-serif;\r\n  border-bottom: 2px solid var(--secondary-text);\r\n}\r\n\r\n#root {\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n::-moz-selection {\r\n  color: var(--bg-color);\r\n  background: var(--secondary-text);\r\n}\r\n\r\n.light-theme ::-moz-selection {\r\n  background-color: var(--alt-color);\r\n  color: var(--alt-color);\r\n}\r\n\r\n::selection {\r\n  color: var(--bg-color);\r\n  background: var(--secondary-text);\r\n}\r\n\r\n.light-theme ::selection {\r\n  background-color: var(--primary-text);\r\n  color: var(--alt-color);\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 12px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background-color: var(--secondary-text);\r\n  border-radius: 6px;\r\n  border: 3px solid transparent;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background-color: var(--secondary-text);\r\n}\r\n\r\nhtml {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: var(--secondary-text) transparent;\r\n}\r\n\r\n::-webkit-scrollbar-button {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
